import { Company } from "../interface/company";
import { Labor } from "../interface/labor";
import { BOOLEAN_TWO } from "../shared/common-enums/boolean-two";
import { laborStates } from "../shared/lists/labor-states";
import { RO_STATES } from "../shared/lists/ro-states";
import { ApiFloat } from "./api-float";
import { MkgOS } from "./mkg-os";
import { Utilities } from "./utilities";

export class LaborUtilities extends Utilities {

  static changed(a: Labor, b: Labor): boolean {
    return !this.equalString(a.description, b.description)
      || !this.equalString(a.code, b.code)
      || !this.equalNumberWithDefault(a.saleValue, b.saleValue, 0)
      || a.group !== b.group
      || a.serviceType !== b.serviceType
      || a.KmToChange !== b.KmToChange
      || a.monthToChange !== b.monthToChange
      || a.free !== b.free
      || a.LCCode !== b.LCCode
      || a.CNAE !== b.CNAE
      || !this.equalString(a.observation, b.observation);
  }

  static complyAPI(labor: Labor): any {
    const resp = {
      id: labor.id,
      description: labor.description,
      serviceType: labor.serviceType,
      code: `${labor.code}`?.trim(),
      saleValue: ApiFloat(labor.saleValue),
      KmToChange: Number(labor.KmToChange) || '',
      monthToChange: labor.monthToChange,
      LCCode: Number(labor.LCCode),
      free: labor.free,
      CNAE: labor.CNAE,
      group: labor.groupObject ? labor.groupObject._id : "",
      observation: labor.observation || "",
      messageTime: labor.messageTime,
      custom: labor.custom,
      CSLL: labor.CSLL.aliquot || labor.CSLL.msg ? labor.CSLL : {},
      INSS: labor.INSS.aliquot || labor.INSS.msg ? labor.INSS : {},
      IRPJ: labor.IRPJ.aliquotLabor || labor.IRPJ.msg ? labor.IRPJ : {},
    };
    for (const key of Object.keys(resp)) {
      if ([undefined, null, ""].includes(resp[key]) || Number.isNaN(resp[key])) {
        delete resp[key];
      }
    }
    if (!resp.LCCode) {
      resp.LCCode = '' as any;
    }
    return resp;
  }

  static getAvailableStateToAdd(companyComplementaryOs: Company["complementaryOS"], roCurrentState: MkgOS["currentState"]): number {
    if (companyComplementaryOs === BOOLEAN_TWO.TRUE) {
      return roCurrentState > RO_STATES.authorization ? laborStates.additional.id : laborStates.waiting.id;
    } else {
      return roCurrentState > RO_STATES.authorization ? laborStates.approved.id : laborStates.waiting.id;
    };
  }
}
